const initState = {
  list: [],
  max_price: 0,
  total_count: 0
};

const searchReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_LISTING_BEGIN":
      // console.log("Listing success", action.listing);
      return {
        ...state,
        isLoading: true,
        isListLoading: true
      };

    case "GET_LISTING_LOADING":
      // console.log("Listing success", action.listing);
      return {
        ...state,
        isLoading: false,
        isListLoading: true
      };

    case "GET_LISTING_MAP":
      // console.log("Listing success", action.max_price);
      return {
        ...state,
        list: action.listing && action.listing.list ? action.listing.list : [],
        max_price:
          action.listing && action.listing.max_price
            ? action.listing.max_price
            : 0,
        total_count:
          action.listing && action.listing.total_count
            ? action.listing.total_count
            : 0,
        isLoading: false,
        isListLoading: false
      };
    case "GET_LISTING":
      return {
        ...state,
        list:
          action.listing && action.listing.list
            ? state.list.concat(action.listing.list)
            : [],
        max_price:
          action.listing && action.listing.max_price
            ? action.listing.max_price
            : 0,
        total_count:
          action.listing && action.listing.total_count
            ? action.listing.total_count
            : 0,
        isLoading: false,
        isListLoading: false
      };
    case "GET_LISTING_ERROR":
      // console.log("Listing error", action.err);
      return state;
    default:
      return state;
  }
};

export default searchReducer;
